import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import AppLayout from './components/Layout/AppLayout';
import ProtectedRoute from './components/Layout/ProtectedRoute';
import Login from './pages/Auth/Login';
import Signup from './pages/Auth/Signup';
import ForgotPassword from './pages/Auth/ForgotPassword';
import LanguageSelect from './pages/Auth/LanguageSelect';
import Dashboard from './pages/Dashboard/Dashboard';
import Reports from './pages/Reports/Reports';
import Farms from './pages/Farms/Farms';
import Crops from './pages/Crops/Crops';
import CropList from './pages/Crops/CropList';
import CropDetail from './pages/Expenses/CropDetail';
import AddExpensePage from './pages/Expenses/AddExpensePage';
import AddSalePage from './pages/Sales/AddSalePage';
import AddCropPage from './pages/Crops/AddCropPage';
import Accounts from './pages/Accounts/Accounts';
import AccountDetail from './pages/Accounts/AccountDetail';
import Market from './pages/Market/Market';
import Weather from './pages/Weather/Weather';
import Notifications from './pages/Notifications/Notifications';
import Refer from './pages/Refer/Refer';
import Settings from './pages/Settings/Settings';
import UserAccess from './pages/UserAccess/UserAccess';
import GISViewer from './pages/GIS/GISViewer';
import Plots from './pages/Plots/Plots';
import PlotDetail from './pages/Plots/PlotDetail';
import AdminUsers from './pages/Admin/AdminUsers';
import AdminSubscriptions from './pages/Admin/AdminSubscriptions';
import AdminUserDetail from './pages/Admin/AdminUserDetail';
import AdminPromoters from './pages/Admin/AdminPromoters';
import AdminRedeemBalance from './pages/Admin/AdminRedeemBalance';
import AdminHelp from './pages/Admin/AdminHelp';
import AdminNotifications from './pages/Admin/AdminNotifications';
import AdminCropDiseases from './pages/Admin/AdminCropDiseases';
import AdminCRM from './pages/Admin/AdminCRM';
import AdminCropData from './pages/Admin/AdminCropData';
import AdminCropRaw from './pages/Admin/AdminCropRaw';
import AdminCropGrowers from './pages/Admin/AdminCropGrowers';
import AdminCropMap from './pages/Admin/AdminCropMap';
import StockPage from './pages/Stock/StockPage';
import DailyExpensePage from './pages/DailyExpense/DailyExpensePage';
import BankAccountsPage from './pages/BankAccounts/BankAccountsPage';

const theme = {
  token: {
    colorPrimary: '#1a6b2a',
    borderRadius: 8,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },
};

export default function App() {
  return (
    <ConfigProvider theme={theme}>
      <Routes>
        <Route path="/select-language" element={<LanguageSelect />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />

        <Route path="/" element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="reports" element={<Reports />} />
          <Route path="crops" element={<CropList />} />
          <Route path="farms" element={<Farms />} />
          <Route path="farms/:farmId/farm" element={<Crops />} />
          <Route path="farms/:farmId/farm/:cropId/expenses" element={<CropDetail />} />
          <Route path="farms/:farmId/farm/add-crop" element={<AddCropPage />} />
          <Route path="farms/:farmId/farm/:cropId/edit-crop" element={<AddCropPage />} />
          <Route path="farms/:farmId/farm/:cropId/add-expense" element={<AddExpensePage />} />
          <Route path="farms/:farmId/farm/:cropId/add-sale" element={<AddSalePage />} />
          <Route path="farms/:farmId/plots/:plotId/gis" element={<GISViewer />} />
          <Route path="plots" element={<Plots />} />
          <Route path="plots/:plotId" element={<PlotDetail />} />
          <Route path="accounts" element={<Accounts />} />
          <Route path="accounts/:accountId" element={<AccountDetail />} />
          <Route path="bank-accounts" element={<BankAccountsPage />} />
          <Route path="market" element={<Market />} />
          <Route path="weather" element={<Weather />} />
          <Route path="notifications" element={<Notifications />} />
          <Route path="refer" element={<Refer />} />
          <Route path="settings" element={<Settings />} />
          <Route path="user-access" element={<UserAccess />} />
          <Route path="stock" element={<StockPage />} />
          <Route path="daily-expense" element={<DailyExpensePage />} />
          <Route path="admin/users" element={<AdminUsers />} />
          <Route path="admin/subscriptions" element={<AdminSubscriptions />} />
          <Route path="admin/users/:userId" element={<AdminUserDetail />} />
          <Route path="admin/promoters"      element={<AdminPromoters />} />
          <Route path="admin/redeem-balance" element={<AdminRedeemBalance />} />
          <Route path="admin/help"           element={<AdminHelp />} />
          <Route path="admin/notifications"  element={<AdminNotifications />} />
          <Route path="admin/crop-diseases" element={<AdminCropDiseases />} />
          <Route path="admin/crm" element={<AdminCRM />} />
          <Route path="admin/crop-data" element={<AdminCropData />} />
          <Route path="admin/crop-raw" element={<AdminCropRaw />} />
          <Route path="admin/crop-growers" element={<AdminCropGrowers />} />
          <Route path="admin/crop-map" element={<AdminCropMap />} />
        </Route>

        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </ConfigProvider>
  );
}
